// src/pages/auth/AuthLeftPanel.js
import React from 'react';

const userChips = [
  { icon: 'bi-grid-3x3-gap-fill', label: 'Vastu Grid' },
  { icon: 'bi-house-fill',        label: 'Floor Plans' },
  { icon: 'bi-file-earmark-pdf-fill', label: 'PDF Reports' },
  { icon: 'bi-shield-check',      label: 'Secure Data' },
  { icon: 'bi-compass-fill',      label: 'Directions' },
  { icon: 'bi-bar-chart-line-fill', label: 'Analytics' },
];

const adminChips = [
  { icon: 'bi-people-fill',        label: 'Users' },
  { icon: 'bi-credit-card-fill',   label: 'Plans' },
  { icon: 'bi-graph-up-arrow',     label: 'Analytics' },
  { icon: 'bi-shield-fill-check',  label: 'Security' },
  { icon: 'bi-bell-fill',          label: 'Alerts' },
  { icon: 'bi-gear-fill',          label: 'Settings' },
];

const AuthLeftPanel = ({ adminMode = false }) => {
  const chips = adminMode ? adminChips : userChips;

  return (
    <div className="auth-left">
      <div className="auth-left-blob auth-left-blob-1"></div>
      <div className="auth-left-blob auth-left-blob-2"></div>
      <div className="auth-left-blob auth-left-blob-3"></div>
      <div className="auth-left-grid"></div>

      <div className="auth-left-content">

        {/* Brand */}
        <div className="auth-left-brand">
          <div className="auth-left-brand-icon">
            <i className="bi bi-compass-fill"></i>
          </div>
          <span className="auth-left-brand-name">VastuAnalyzer</span>
        </div>

        {/* Compass */}
        <div className="auth-vastu-visual">
          <svg viewBox="0 0 220 220" width="200" height="200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g className="auth-vastu-ring-outer">
              <circle cx="110" cy="110" r="100" stroke="rgba(0,200,180,0.18)" strokeWidth="1" strokeDasharray="8 6"/>
              {[0,45,90,135,180,225,270,315].map((deg, i) => (
                <g key={i} transform={`rotate(${deg} 110 110)`}>
                  <line x1="110" y1="10" x2="110" y2="26" stroke="rgba(0,200,180,0.5)" strokeWidth="2" strokeLinecap="round"/>
                </g>
              ))}
            </g>
            <g className="auth-vastu-ring-mid">
              <circle cx="110" cy="110" r="72" stroke="rgba(0,161,157,0.25)" strokeWidth="1.5" strokeDasharray="5 4"/>
            </g>
            {/* 3×3 Vastu grid */}
            <g opacity="0.45">
              <rect x="68" y="68" width="48" height="48" rx="3" stroke="#00A19D" strokeWidth="1.2"/>
              <line x1="84" y1="68" x2="84" y2="116" stroke="#00A19D" strokeWidth="0.7"/>
              <line x1="100" y1="68" x2="100" y2="116" stroke="#00A19D" strokeWidth="0.7"/>
              <line x1="68" y1="84" x2="116" y2="84" stroke="#00A19D" strokeWidth="0.7"/>
              <line x1="68" y1="100" x2="116" y2="100" stroke="#00A19D" strokeWidth="0.7"/>
            </g>
            <g className="auth-vastu-pulse">
              <circle cx="110" cy="110" r="10" fill="rgba(0,212,207,0.15)" stroke="#00d4cf" strokeWidth="1.5"/>
              <circle cx="110" cy="110" r="4" fill="#00d4cf"/>
            </g>
            {[{l:'N',x:110,y:6},{l:'S',x:110,y:218},{l:'E',x:218,y:113},{l:'W',x:2,y:113}].map(p => (
              <text key={p.l} x={p.x} y={p.y} textAnchor="middle" dominantBaseline="central"
                fontSize="11" fontWeight="700" fill="rgba(0,212,207,0.65)" fontFamily="Inter,sans-serif">{p.l}</text>
            ))}
          </svg>
        </div>

        {/* Tagline — single line */}
        <h2 className="auth-left-title">
          {adminMode
            ? <><span>Admin</span> Control Panel</>
            : <>Analyze. Optimize. <span>Flourish.</span></>
          }
        </h2>

        {/* Tool chips grid */}
        <div className="auth-left-chips">
          {chips.map((c, i) => (
            <div className="auth-left-chip" key={i}>
              <i className={`bi ${c.icon}`}></i>
              <span>{c.label}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default AuthLeftPanel;
